var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHostedPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.49 18.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,0H2.46A2.46,2.46,0,0,0,0,2.46V16.14A2.46,2.46,0,0,0,2.46,18.6H21a2.46,2.46,0,0,0,2.46-2.46V2.46A2.46,2.46,0,0,0,21,0ZM2.46,1H21a1.46,1.46,0,0,1,1.46,1.46V4.89H1V2.46A1.46,1.46,0,0,1,2.46,1ZM21,17.6H2.46A1.46,1.46,0,0,1,1,16.14V5.89H22.49V16.14A1.46,1.46,0,0,1,21,17.6ZM3.43,3A.58.58,0,0,1,4.58,3,.58.58,0,0,1,3.43,3Zm2.5,0A.57.57,0,1,1,7.07,3,.57.57,0,0,1,5.93,3ZM8.42,3A.58.58,0,1,1,9,3.6.58.58,0,0,1,8.42,3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostedPayments);
export default __webpack_public_path__ + "static/media/hosted-payments.de21dd407f563006734c97ff37a01624.svg";
export { ForwardRef as ReactComponent };